import "./Philosophy.scss";

const Philosophy = () => {
  return (
    <main id="philosophy-page">
      <div className="philosophy-page-container">
        <div className="header">
          <h1>Philosophy of Education</h1>
        </div>
        <div className="philosophy-content">
          <p>
            As educators, we have a significant influence on the lives of the
            children we teach. Our actions and decisions can shape their
            futures, whether by encouraging their interests and talents or by
            guiding them towards new opportunities. Understanding this
            responsibility, I am committed to making thoughtful and positive
            decisions that support each student's development. It is important
            to recognize that our words and actions can have lasting effects,
            and I aim to use this influence constructively, fostering an
            environment where students can explore and grow.
          </p>
          <p>
            While classroom management is a key aspect of teaching, it is
            equally important to involve students in the learning process and
            give them a voice in their education. By creating an environment
            where students feel heard and valued, we help them understand that
            they are active participants in their own learning and in the
            broader classroom community. This approach empowers students to take
            initiative and contribute to their environment, promoting a sense of
            ownership and responsibility.
          </p>
          <p>
            A classroom should be a safe and supportive community where students
            feel comfortable being themselves and expressing their thoughts and
            ideas. In such a setting, students are more likely to engage fully
            and develop a strong sense of belonging. Creating this type of
            community requires a commitment to inclusivity and understanding,
            where every student is recognized and respected for who they are.
          </p>
          <p>
            To foster this inclusive environment, it is essential to provide
            students with both "windows" and "mirrors." Windows allow students
            to gain insight into the experiences of others, fostering empathy
            and understanding. Mirrors reflect students' own experiences,
            helping them feel seen and understood. By balancing these elements,
            we can help students appreciate diversity and develop a broader
            perspective.
          </p>
          <p>
            A classroom community is dynamic and ever-changing. With each new
            student, the community evolves, requiring flexibility and
            adaptability from both educators and students. This fluidity ensures
            that everyone feels welcome and included, and that the classroom
            remains a space where all students can thrive.
          </p>
          <p>
            Diversity in the classroom is a strength, bringing a wide range of
            cognitive and cultural resources that can enhance learning.
            Effective educators recognize and utilize these resources, creating
            lessons that are meaningful and engaging for all students. By
            incorporating students' backgrounds and experiences into the
            curriculum, we validate their identities and make learning more
            relevant and accessible.
          </p>
          <p>
            Recognizing that each student is an individual with unique learning
            needs is crucial to effective teaching. While it is important to
            maintain high expectations and standards, it is equally important to
            tailor instruction to meet the diverse needs of students.
            Understanding students as individuals allows us to provide the
            support and encouragement they need to succeed.
          </p>
          <p>
            Finally, the foundation of effective education is the relationships
            we build with our students. Positive relationships create a
            supportive learning environment where students feel valued and
            understood. Whether it’s through attending a student’s
            extracurricular activities, engaging with them during free time, or
            involving families in the learning process, these connections are
            key to fostering a positive and lasting impact on students' lives.
          </p>
          <p>
            In conclusion, my philosophy of education is centered on creating a
            supportive, inclusive, and engaging learning environment where all
            students are empowered to reach their full potential. By focusing on
            relationships, inclusivity, and individualized instruction, I aim to
            help each student succeed both academically and personally.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Philosophy;
